// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile:
      (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
  $('#wrapper').addClass('setTouch');
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
// $(function () {
//   // setScroll();
//   // if ($('#wrapper').hasClass('home')) {
//   //   setWave();
//   // }
//   // ///////////
//   // if (!_ua.Mobile && !_ua.Tablet) {
//   //   $('#wrapper').addClass('desktop');
//   //   if (!$('#wrapper').hasClass('about')) {
//   //     $('html, body').prop({
//   //       scrollTop: 0,
//   //     });
//   //     if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
//   //       // ここにSafari用の記述
//   //     } else {
//   //     }
//   //   }
//   // }
//   // ///////////
// });

$(window).on('load', function () {
  heightLineGroup();
  judgeWinSize();
  setHeader();
  // setGnav();
  setLoaded();
  setSpan();
  if (!$('#wrapper').hasClass('philosophyProd')) {
    setWay();
  }
  // setInview();
  setAcc();
  setMegaMenu();
  // setScrollTop();
  // setWay();
  // setSpan();
  setMainMenu();
  setSearchToggle();
  mailTo();
  if ($('#wrapper').hasClass('home')) {
    setRellax();
    setClock();
    setSlider_01();
    setSlider_02();
    setSlider_03();
    setSlider_04();
    setSlider_06();
    setGlobalMap();
    setHomeFv();
    // setSphere();
  } else if ($('#wrapper').hasClass('company')) {
    // setRellax();
    setSlider_02();
    setModal();
    setHistory();
    setGlobalMap();
    // setGsap();
  } else if ($('#wrapper').hasClass('news-archive') || $('#wrapper').hasClass('single-news')) {
    setSlider_05();
  } else if (
    $('#wrapper').hasClass('sustainability') ||
    $('#wrapper').hasClass('sustainability-en')
  ) {
    setSlider_03();
    setRellax();
    setScrollHint();
  } else if (
    $('#wrapper').hasClass('sustainability-child') ||
    $('#wrapper').hasClass('sustainability-child-en')
  ) {
    setSlider_07();
    setScrollHint();
    setFancy();
  } else if ($('#wrapper').hasClass('tcfd') || $('#wrapper').hasClass('tcfd-en')) {
    setScrollHint();
  } else if ($('#wrapper').hasClass('esg') || $('#wrapper').hasClass('esg-en')) {
    setSlider_08();
    setScrollHint();
  } else if ($('#wrapper').hasClass('philosophy') && $('#wrapper').hasClass('philosophyProdTest')) {
    setRellax();
  } else if ($('#wrapper').hasClass('ir-plan') || $('#wrapper').hasClass('ir-plan-en')) {
    setScrollHint();
  } else if ($('#wrapper').hasClass('recruit')) {
    setRellax();
  } else if ($('#wrapper').hasClass('setSlideFv')) {
    setSlideFv();
    setRellax();
  } else if (
    $('#wrapper').hasClass('ir-stock-dividend') ||
    $('#wrapper').hasClass('ir-stock-dividend-en') ||
    $('#wrapper').hasClass('ir-policy') ||
    $('#wrapper').hasClass('ir-policy-en')
  ) {
    setScrollHint();
  } else if ($('#wrapper').hasClass('contact')) {
    setForm();
  }
  startScroll();
});

//fancybox
function setFancy() {
  $('.setFancy').fancybox({
    // オプションを下記に記載していきます
    // animationEffect: 'zoom-in-out', //アニメーションをズームインアウトに
    // loop: true, // 複数画像表示時に最初と最後をループさせる
    toolbar: false, // ツールバーの非表示
    // smallBtn: true, // 小さいCloseボタン利用する
    // iframe: {
    //   // iframe 関連の処理
    //   preload: false, //iframeのプリロードをしない
    // },
  });
}

// /////フォーム制御
function setForm() {
  $('.wpcf7-tel').attr('pattern', '\\d*');
  $('.wpcf7-tel').attr(
    'onkeyup',
    'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")'
  );

  $('input[name="acceptance-form"]').change(function () {
    var prop = $(this).prop('checked');
    if (prop) {
      $('#confirmBtn').removeClass('off');
    } else {
      $('#confirmBtn').addClass('off');
    }
  });

  $('#js-count').keyup(function () {
    var count = $(this).val().length;
    $('.show-count').text(count);
  });

  $('#confirmBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7-previous').click();
  });
  $('#submitBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  // /////エラーのとき
  // document.addEventListener(
  //   'wpcf7invalid',
  //   function (event) {
  //     setTimeout(function () {
  //       var position = $('.wpcf7-not-valid-tip:first').offset().top - 300;
  //       $('html,body').animate(
  //         {
  //           scrollTop: position,
  //         },
  //         {
  //           queue: false,
  //         }
  //       );
  //     }, 100);
  //   },
  //   false
  // );
  // // /////成功のとき
  // document.addEventListener(
  //   'wpcf7mailsent',
  //   function (event) {
  //     $('html,body').animate(
  //       {
  //         scrollTop: 0,
  //       },
  //       {
  //         queue: false,
  //       }
  //     );
  //   },
  //   false
  // );

  var urlHash = location.search;
  // URLにアンカーが存在する場合
  if (urlHash) {
    urlHash = urlHash.replace('?subject_', '').replace('?', '');
    if (urlHash == 'company_1') {
      var target = 'select[name="contact_company"]';
      target = $(target);
      if ($('body').hasClass('page-template-page-contact-en')) {
        target.val('Valuence Japan Inc.');
      } else {
        target.val('バリュエンスジャパン');
      }
    } else if (urlHash == 'company_2') {
      var target = 'select[name="contact_company"]';
      target = $(target);
      if ($('body').hasClass('page-template-page-contact-en')) {
        target.val('Valuence International Limited');
      } else {
        target.val('バリュエンスインターナショナル');
      }
    } else if (urlHash == 'company_3') {
      var target = 'select[name="contact_company"]';
      target = $(target);
      if ($('body').hasClass('page-template-page-contact-en')) {
        target.val('Valuence Technologies Inc.');
      } else {
        target.val('バリュエンステクノロジーズ');
      }
    } else if (urlHash == 'company_4') {
      var target = 'select[name="contact_company"]';
      target = $(target);
      if ($('body').hasClass('page-template-page-contact-en')) {
        target.val('Valuence Ventures Inc.');
      } else {
        target.val('バリュエンスベンチャーズ');
      }
    } else if (urlHash == 'company_5') {
      var target = 'select[name="contact_company"]';
      target = $(target);
      if ($('body').hasClass('page-template-page-contact-en')) {
        target.val('YONE MOTORS Inc.');
      } else {
        target.val('米自動車');
      }
    } else if (urlHash == '5') {
      var target = 'select[name="contact_type"]';
      target = $(target);
      if ($('body').hasClass('page-template-page-contact-en')) {
        target.val('External Reporting');
      } else {
        target.val('外部通報');
      }
    }
  }
}

//メアドスパム対策
function mailTo() {
  $('.mailTo').click(function () {
    var address = $(this).attr('href').replace('+', '@');
    location.href = 'mailto:' + address;
    return false;
  });
}

//スクロールヒント
function setScrollHint() {
  $('.scrollHintSec').scroll(function () {
    $(this).parent().find('.scroll-hint-icon-wrap').fadeOut();
    // スクロールしたときの処理内容を記述する
  });
  // new ScrollHint('.js-scrollHint', {
  //   i18n: {
  //     scrollable: 'スクロールできます',
  //   },
  // });
}

//ヘッダ検索メニュー
function setSearchToggle() {
  $('.search-toggle').on('click', function () {
    $('#wrapper').addClass('searchOn');
    $('input.search-field').focus();
  });
  if ($('#wrapper').hasClass('setPc')) {
    // $('header .searchSec').hover(
    $('header').hover(
      function () {},
      function () {
        $('#wrapper').removeClass('searchOn');
      }
    );
  }
}

//メガメニュー
function setMegaMenu() {
  if ($('#wrapper').hasClass('setPc')) {
    $('header .hasChild').hover(
      function () {
        // $('.globalNav .parent>li>a').removeClass('active');
        $('.menuSection').removeClass('active');
        // $(this).find('>a').addClass('active');
        const target = $(this).find('.menuSection');
        $('#wrapper').addClass('headPanel');
        target.addClass('active');
        // console.log(target.height());
        const bgHeight = 150 + target.height() + 90 + 20;
        $('#headerBg').height(bgHeight);
      },
      function () {
        $(this).find('>a').removeClass('active');
        $('.menuSection').removeClass('active');
        $('#wrapper').removeClass('headPanel');
        $('#headerBg').height(0);
      }
    );
  }
}

//history画像
function setHistory() {
  $('.setSp .historySec .imgWrap').on('click', function () {
    $('.historyItem .list').removeClass('is-showSp');
  });
  $('.setSp .historySec .link').on('click', function () {
    $('.historyItem .list').removeClass('is-showSp');
    $(this).parents('.list').addClass('is-showSp');
  });

  $('.setPc .historySec .link').hover(
    function () {
      $('.historyItem .list').removeClass('is-active');
      var target = $(this).parents('.list');
      target.addClass('is-fade');
      target.addClass('is-active');
    },
    function () {
      var target = $(this).parents('.list');
      target.removeClass('is-active');
      target.removeClass('currentHistory');
    }
  );

  $('.historySec .scroller').scroll(function () {
    $('.historyItem .list').removeClass('is-showSp');

    const baseX = $(this).offset().top + 300;
    $('.history-way').each(function (index) {
      const itemX = $(this).offset().top;
      if (itemX < baseX) {
        // $('.historyItem .list').removeClass('is-active');
        $(this).addClass('is-active');
      }
    });

    $('.history-way .list').each(function (index) {
      const itemX = $(this).offset().top;
      // const group = $(this).data('group');
      // const target = $('.history-way .list[data-group="' + group + '"]');
      if (itemX < baseX) {
        $(this).addClass('is-fade');
        if (
          $(this).nextAll().hasClass('is-active') &&
          $(this).nextAll().find('.link').length != 0
        ) {
          // $(this).removeClass('currentHistory');
          $(this).removeClass('is-active');
        } else {
          if ($(this).find('.link').length != 0) {
            $(this).addClass('is-active');
          }
          // $(this).addClass('currentHistory');
        }
      } else {
        if (itemX > baseX + 100) {
          if (!$(this).hasClass('first')) {
            $(this).removeClass('is-active');
            $(this).removeClass('currentHistory');
          }
        }
      }
    });
  });
  // gsap.from('.scrub_01', {
  //   // duration: 1,
  //   // autoAlpha: 0,
  //   // // y: 20,
  //   // scale: 0,
  //   scrollTrigger: {
  //     trigger: '.trigger_01',
  //     markers: true,
  //     end: '600%',
  //     onLeave: () => {
  //       pause();
  //     },
  //     // toggleClass: { targets: '.gtarget_01', className: 'is-active' },
  //     // once: false,
  //     // scrub: true,
  //     // scrub: 1, //1秒間アニメーションする
  //     // onLeave: () => {
  //     //   console.log('aaa');
  //     //   $('.gtarget_01').removeClass('is-active');
  //     // },
  //   },
  // });
  // gsap.from('.scrub_02', {
  //   duration: 1,
  //   autoAlpha: 0,
  //   // y: 20,
  //   scale: 0,
  //   scrollTrigger: {
  //     toggleClass: { targets: el, className: 'is-active' },
  //   },
  // });
  // $('.historySec .scroller').scroll(function () {
  //   const baseX = $(this).offset().top;
  //   $('.historyItem').each(function (index) {
  //     const itemX = $(this).offset().top;
  //     if (itemX < baseX) {
  //       $(this).addClass('is-active');
  //     }
  //   });
  // });
  // $('.history-way').on('inview', function () {
  //   var activePoint = $(this);
  //   activePoint.addClass('is-active-h');
  //   timer = setTimeout(function () {
  //     activePoint.addClass('is-active-after-h');
  //   }, 500);
  // });
  // $('.historyWay').on('inview', function (event, isInView, visiblePartX, visiblePartY) {
  //   var activePoint = $(this);
  //   if (isInView) {
  //     activePoint.addClass('is-active');
  //   }
  // });
  // if ($('#wrapper').hasClass('setPc')) {
  //   $('.historyItem .link').hover(
  //     function () {
  //       $(this).parents('.historyItem').addClass('is-active');
  //     },
  //     function () {
  //       $(this).parents('.historyItem').removeClass('is-active');
  //     }
  //   );
  // }
}

// Rellax
function setRellax() {
  var rellax = new Rellax('.js-rellax');
}

var current_scrollY = 0;
///モーダル
function setModal() {
  $('.js-modal').on('click', function () {
    if (!$('#wrapper').hasClass('modalOpen')) {
      const target = '#' + $(this).data('modal');
      modalOpenFnc(target);
    } else {
      closeModalFnc();
    }
  });
  $('#modalWrapper .closeArea,.modalClose,#modalWrapper .closeBtn').on('click', function () {
    if ($('#wrapper').hasClass('modalOpen')) {
      closeModalFnc();
    }
  });
}

function modalOpenFnc(target) {
  current_scrollY = $(window).scrollTop();
  $(target).addClass('is-active');
  $('#wrapper').addClass('modalOpen');
  $('#outerMenu').css('top', -current_scrollY);
  setTimeout(function () {
    $('html, body').prop({
      scrollTop: 0,
    });
  }, 100);
}

function closeModalFnc() {
  $('.modalStyle').removeClass('is-active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('modalOpen');
  $('html, body').prop({
    scrollTop: current_scrollY,
  });
}

// //////////////////////////メインメニュー
function setMainMenu() {
  $('#mainMenu').on('click', function () {
    if (!$('#mainMenu').hasClass('active')) {
      openFnc();
    } else {
      closeFnc();
    }
  });
  // $('#mainNav a').on('click', function (event) {
  //   event.stopPropagation()
  // })
  //
  $('#clickBlocker,#menuPanel .closeBtn,#menuPanel .closeArea,#menuPanel .mainNav').on(
    'click',
    function (event) {
      event.stopPropagation();
      closeFnc();
    }
  );

  $('.mainNav a').on('click', function (event) {
    event.stopPropagation();
  });

  //タブレット対応リサイズバグ誘発のため一時停止
  // var winW = $(window).width();
  // var timer = false;
  // var currentWidth = window.innerWidth;
  // window.addEventListener('resize', function () {
  //   winW = $(window).width();
  //   if (currentWidth == window.innerWidth) {
  //     return;
  //   }
  //   currentWidth = window.innerWidth;
  //   if (timer !== false) {
  //     clearInterval(timer);
  //   }
  //   timer = setTimeout(function () {
  //     if (winW > tabletNum) {
  //       closeFnc();
  //     }
  //   }, 200);
  // });
}

function openFnc() {
  current_scrollY = $(window).scrollTop();
  $('#mainMenu').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('#outerMenu').css('top', -current_scrollY);
  // 検索補助
  // $('header .btnSubmit').removeClass('search-url')
  // $('#menuPanel .btnSubmit').addClass('search-url')
  setTimeout(function () {
    $('html, body').prop({
      scrollTop: 0,
    });
  }, 100);
}

function closeFnc() {
  $('#mainMenu').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  // 検索補助
  // $('header .btnSubmit').addClass('search-url')
  // $('#menuPanel .btnSubmit').removeClass('search-url')
  $('html, body').prop({
    scrollTop: current_scrollY,
  });
}

//GlobalMap制御
function setGlobalMap() {
  const mapInfoArr = [];
  $('.globalActionMap .item').each(function (index) {
    var Elem = $(this).find('.inner').html();
    $('.spInfo').append(Elem);
    $('.spInfo .cel:first-child').addClass('active');
    $('.globalActionMap .item:first-child').addClass('active');
    // mapInfoArr.push($(this).find('.cel').html());
    // $('.spInfo').html(mapInfoArr[index]);
  });
  $('.globalActionMap .item').on('click', function (event) {
    if ($('#wrapper').hasClass('setSp')) {
      $('.globalActionMap .item').removeClass('active');
      $(this).addClass('active');
      var myIndex = $(this).index() + 1;
      var target = '.spInfo .cel:nth-child(' + myIndex + ')';
      $('.spInfo .cel').removeClass('active').hide();
      $(target).fadeIn();
    }
  });
  if ($('#wrapper').hasClass('setPc')) {
    $('.globalActionMap .item').hover(
      function () {
        $('.globalActionMap .item').addClass('other');
        $(this).removeClass('other');
      },
      function () {
        $('.globalActionMap .item').removeClass('other');
      }
    );
  }
}

// カルーセル
function setSlider_01() {
  const mySwiperMain = new Swiper('.carouselStyle_01 .swiper-main', {
    slidesPerView: 1,
    spaceBetween: 20,
    // centeredSlides: true,
    loop: true, // 無限ループさせる
    loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    autoplay: {
      // 自動再生させる
      delay: 8000, // 次のスライドに切り替わるまでの時間（ミリ秒）
      disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
      waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    // breakpoints: {
    //   // スライドの表示枚数：500px以上の場合
    //   769: {
    //     slidesPerView: 1.2,
    //   },
    // },
  });
}

function setSlider_02() {
  const mySwiperMain = new Swiper('.carouselStyle_02 .swiper-main', {
    watchSlidesProgress: true,
    slidesPerView: 2,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    // autoplay: {
    //   // 自動再生させる
    //   delay: 8000, // 次のスライドに切り替わるまでの時間（ミリ秒）
    //   disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
    //   waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    // },
    mousewheel: {
      forceToAxis: true,
    },
    on: {
      // イベントを登録する
      slideChange: (swiper) => {
        // $('.vinSec .swiper-slide-visible .count').text(0);
        setCountAnime();
      },
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      769: {
        slidesPerView: 3,
      },
    },
  });
}

function setSlider_03() {
  let swiper, swiperbool;
  const breakPoint = breakNum;

  if (breakPoint > window.innerWidth) {
    swiperbool = false;
  } else {
    createSwiper();
    swiperbool = true;
  }

  window.addEventListener(
    'resize',
    () => {
      if (breakPoint > window.innerWidth && swiperbool) {
        swiper.destroy(false, true);
        swiperbool = false;
      } else if (breakPoint <= window.innerWidth && !swiperbool) {
        createSwiper();
        swiperbool = true;
      }
    },
    false
  );

  function createSwiper() {
    swiper = new Swiper('.carouselStyle_03 .swiper-main', {
      slidesPerView: 3,
      spaceBetween: 24,
      threshold: 10,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    });
  }
}

function setSlider_04() {
  const mySwiperMain = new Swiper('.carouselStyle_04 .swiper-main', {
    slidesPerView: 1.2,
    spaceBetween: 24,
    threshold: 10,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      769: {
        slidesPerView: 2.5,
      },
    },
  });
}

function setSlider_05() {
  let swiper, swiperbool;
  const breakPoint = breakNum;
  const countSwiper = $('.carouselStyle_05').length;

  if (breakPoint > window.innerWidth) {
    swiperbool = false;
  } else {
    createSwiper();
    swiperbool = true;
  }

  window.addEventListener(
    'resize',
    () => {
      if (breakPoint > window.innerWidth && swiperbool) {
        for (let i = 0; i < countSwiper; i++) {
          swiper[i].destroy(false, true);
        }
        swiperbool = false;
      } else if (breakPoint <= window.innerWidth && !swiperbool) {
        createSwiper();
        swiperbool = true;
      }
    },
    false
  );

  function createSwiper() {
    swiper = new Swiper('.carouselStyle_05 .swiper-main', {
      slidesPerView: 2,
      spaceBetween: 24,
      threshold: 10,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      speed: 1000, // スライドアニメーションのスピード（ミリ秒）
      breakpoints: {
        1200: {
          slidesPerView: 3,
        },
      },
    });
  }
}

function setSlider_06() {
  const mySwiperMain = new Swiper('.carouselStyle_06 .swiper-main', {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    // centeredSlides: true,
    loop: true, // 無限ループさせる
    loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    autoplay: {
      // 自動再生させる
      delay: 8000, // 次のスライドに切り替わるまでの時間（ミリ秒）
      disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
      waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    // breakpoints: {
    //   // スライドの表示枚数：500px以上の場合
    //   769: {
    //     slidesPerView: 1.2,
    //   },
    // },
  });
}

function setSlider_07() {
  const mySwiperMain = new Swiper('.carouselStyle_07 .swiper-main', {
    watchSlidesProgress: true,
    slidesPerView: 1,
    spaceBetween: 5,
    loop: true, // 無限ループさせる
    // loopedSlides: 3,
    // loopAdditionalSlides: 3, // 無限ループさせる場合に複製するスライド数
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   draggable: true,
    // },
    // autoplay: {
    //   // 自動再生させる
    //   delay: 8000, // 次のスライドに切り替わるまでの時間（ミリ秒）
    //   disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
    //   waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    // },
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.swiper-pagination', //必須
      //使いたいパラメータを追加する
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      // イベントを登録する
      slideChange: (swiper) => {
        setCountAnime();
      },
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      769: {
        spaceBetween: 24,
      },
    },
  });
}

function setSlider_08() {
  const mySwiperMain = new Swiper('.carouselStyle_08 .swiper-main', {
    watchSlidesProgress: true,
    slidesPerView: 1,
    spaceBetween: 5,
    loop: true, // 無限ループさせる
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   draggable: true,
    // },
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.swiper-pagination', //必須
      //使いたいパラメータを追加する
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      // イベントを登録する
      slideChange: (swiper) => {
        setCountAnime();
      },
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      769: {
        spaceBetween: 24,
        loop: false,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
      },
    },
  });
}

//カウンターアニメーション
function setCountAnime() {
  // // $('.vinSec .count').text($(this).data('count'));
  // $(this).text(0);
  // $(
  //   '.vinSec .swiper-slide-visible .count,.carouselStyle_07 .swiper-slide-visible .count,.carouselStyle_08 .swiper-slide-visible .count,.scoreStyle_01 .count'
  // ).each(function () {
  //   // $(this).text(0);
  //   $(this)
  //     .prop('Counter', 0)
  //     .animate(
  //       {
  //         //0からカウントアップ
  //         // Counter: $(this).text(),
  //         Counter: $(this).data('count'),
  //       },
  //       {
  //         // スピードやアニメーションの設定
  //         duration: 2000, //数字が大きいほど変化のスピードが遅くなる。2000=2秒
  //         easing: 'swing', //動きの種類。他にもlinearなど設定可能
  //         step: function (now) {
  //           if ($(this).hasClass('style_01')) {
  //             $(this).text(parseFloat(now.toFixed(1)));
  //           } else {
  //             $(this).text(Math.ceil(now).toLocaleString());
  //           }
  //         },
  //       }
  //     );
  // }, 300);
}

function setCountAnimeU() {
  // // $('.vinSec .count').text($(this).data('count'));
  // $(this).text(0);
  // $(
  //   '.carouselStyle_07 .swiper-slide-visible .count,.carouselStyle_08 .swiper-slide-visible .count'
  // ).each(function () {
  //   // $(this).text(0);
  //   $(this)
  //     .prop('Counter', 0)
  //     .animate(
  //       {
  //         //0からカウントアップ
  //         // Counter: $(this).text(),
  //         Counter: $(this).data('count'),
  //       },
  //       {
  //         // スピードやアニメーションの設定
  //         duration: 2000, //数字が大きいほど変化のスピードが遅くなる。2000=2秒
  //         easing: 'swing', //動きの種類。他にもlinearなど設定可能
  //         step: function (now) {
  //           if ($(this).hasClass('style_01')) {
  //             $(this).text(parseFloat(now.toFixed(1)));
  //           } else {
  //             $(this).text(Math.ceil(now));
  //           }
  //         },
  //       }
  //     );
  // }, 300);
}
// ///////ヘッダー制御
let set_position = 0;
function setHeader() {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
      $('header').removeClass('fixedHeaderDelay');
    }, 10);
  });

  fixedHeader();
  // console.log($('#mainVis').height())

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader() {
    if (
      $('#wrapper').hasClass('home') ||
      $('#wrapper').hasClass('setFv') ||
      $('#wrapper').hasClass('setFv_02')
    ) {
      h = $('.fv').height() - 50;
    } else {
      h = 5;
    }
    baseHeight = h;
    if ($(this).scrollTop() < baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    } else if ($(this).scrollTop() >= baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
    if (set_position < $(this).scrollTop()) {
      $('#wrapper').addClass('scrollDown');
      $('#wrapper').removeClass('scrollUp');
    } else {
      $('#wrapper').addClass('scrollUp');
      $('#wrapper').removeClass('scrollDown');
    }

    set_position = $(this).scrollTop();
    // if ($('#wrapper').hasClass('company')) {
    //   h2 = $('.fv').height() * 2 - 50;
    //   baseHeight = h;
    //   baseHeight2 = h2;
    //   if ($(this).scrollTop() < baseHeight2) {
    //     $('#wrapper').removeClass('fixedHeader');
    //   } else if ($(this).scrollTop() >= baseHeight2) {
    //     $('#wrapper').addClass('fixedHeader');
    //   }
    //   if ($(this).scrollTop() < baseHeight) {
    //     $('#wrapper').removeClass('fixedHeaderDelay');
    //   } else if ($(this).scrollTop() >= baseHeight) {
    //     $('#wrapper').addClass('fixedHeaderDelay');
    //   }
    // } else {
    //   baseHeight = h;
    //   if ($(this).scrollTop() < baseHeight) {
    //     $('#wrapper').removeClass('fixedHeader');
    //   } else if ($(this).scrollTop() >= baseHeight) {
    //     $('#wrapper').addClass('fixedHeader');
    //   }
    // }
  }
}

//時計
function setClock() {
  const clock = () => {
    // 現在の日時・時刻の情報を取得
    const d = new Date();

    // 年を取得
    let year = d.getFullYear();
    // 月を取得
    let monthNum = d.getMonth();
    const monthday = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    let month = monthday[monthNum];
    // 日を取得
    let date = d.getDate();
    // 曜日を取得
    let dayNum = d.getDay();
    const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let day = weekday[dayNum];
    // 時を取得
    let hour24 = d.getHours();
    let hour12 = hour24 % 12;
    let hourStr = hour24 < 12 ? 'AM' : 'PM';
    let hour = hour12;
    // 分を取得
    let min = d.getMinutes();
    // 秒を取得
    let sec = d.getSeconds();

    // 1桁の場合は0を足して2桁に
    date = date < 10 ? '0' + date : date;
    hour = hour < 10 ? '0' + hour : hour;
    min = min < 10 ? '0' + min : min;
    sec = sec < 10 ? '0' + sec : sec;

    // 日付・時刻の文字列を作成
    let today = `${day}\n${date} ${month} ${year} `;
    let time1 = `${hour}`;
    let time2 = `${min} ${hourStr}`;

    // 文字列を出力
    document.querySelector('.clock-date').innerText = today;
    document.querySelector('.clock-hour').innerText = time1;
    document.querySelector('.clock-ot').innerText = time2;
  };

  // 1秒ごとにclock関数を呼び出す
  setInterval(clock, 1000);
}

//GSAP
function setHomeFv() {
  // gsap.to('#wave_01', { scale: 2, duration: 0 });
  gsap.registerPlugin(ScrollTrigger);
  gsap.fromTo(
    '.setPc #homeCover',
    { opacity: 0 }, // 開始時の状態
    {
      opacity: 1, // 終了時の状態
      scrollTrigger: {
        trigger: '#homeConcept', // トリガーになる要素
        start: 'top 80%', // スクロール位置 (例: 要素がビューポートの80%に来たとき)
        end: 'top 50%', // 終了位置 (例: 要素がビューポートの50%に来たとき)
        scrub: true, // スクロールに合わせてアニメーション
      },
    }
  );
  gsap.fromTo(
    '.setPc #homeConcept',
    { opacity: 0 }, // 開始時の状態
    {
      opacity: 1, // 終了時の状態
      scrollTrigger: {
        trigger: '#homeConcept', // トリガーになる要素
        start: 'top 80%', // スクロール位置 (例: 要素がビューポートの80%に来たとき)
        end: 'top 50%', // 終了位置 (例: 要素がビューポートの50%に来たとき)
        scrub: true, // スクロールに合わせてアニメーション
        onEnter: () => {
          document.querySelector('#homeConcept').classList.add('is-active');
          // #mainVisのis-activeクラスを削除
          document.querySelector('#mainVis').classList.remove('is-active');
        },
      },
    }
  );
  gsap.fromTo(
    '.setPc #mainVis .trigger',
    { opacity: 1 }, // 開始時の状態
    {
      opacity: 0, // 終了時の状態
      scrollTrigger: {
        trigger: '#homeConcept', // トリガーになる要素
        start: 'top 80%', // スクロール位置 (例: 要素がビューポートの80%に来たとき)
        end: 'top 50%', // 終了位置 (例: 要素がビューポートの50%に来たとき)
        scrub: true, // スクロールに合わせてアニメーション
      },
    }
  );
  gsap.to('.setPc #homeTrigger', {
    scrollTrigger: {
      trigger: '#homeTrigger', // トリガーになる要素
      start: 'top 80%', // スクロール位置 (例: 要素がビューポートの80%に来たとき)
      end: 'top 50%', // 終了位置 (例: 要素がビューポートの50%に来たとき)
      scrub: true, // スクロールに合わせてアニメーション
      onEnterBack: () => {
        document.querySelector('#homeConcept').classList.remove('is-active');
        document.querySelector('#mainVis').classList.add('is-active');
      },
    },
  });
}

function setSlideFv() {
  // gsap.to('#wave_01', { scale: 2, duration: 0 });
  gsap.registerPlugin(ScrollTrigger);
  gsap.fromTo(
    '#slideVis .item.style_01',
    { opacity: 1 }, // 開始時の状態
    {
      opacity: 0, // 終了時の状態
      scrollTrigger: {
        trigger: '#slideVis .item.style_02', // トリガーになる要素
        start: 'top 80%', // スクロール位置 (例: 要素がビューポートの80%に来たとき)
        end: 'top 50%', // 終了位置 (例: 要素がビューポートの50%に来たとき)
        scrub: true, // スクロールに合わせてアニメーション
      },
    }
  );
  gsap.fromTo(
    '#slideVis .item.style_02',
    { opacity: 0 }, // 開始時の状態
    {
      opacity: 1, // 終了時の状態
      scrollTrigger: {
        trigger: '#slideVis .item.style_02', // トリガーになる要素
        start: 'top 80%', // スクロール位置 (例: 要素がビューポートの80%に来たとき)
        end: 'top 50%', // 終了位置 (例: 要素がビューポートの50%に来たとき)
        scrub: true, // スクロールに合わせてアニメーション
      },
    }
  );
  gsap.fromTo(
    '#slideVis',
    { opacity: 1 }, // 開始時の状態
    {
      opacity: 0, // 終了時の状態
      scrollTrigger: {
        trigger: '#brands', // トリガーになる要素
        start: 'top 80%', // スクロール位置 (例: 要素がビューポートの80%に来たとき)
        end: 'top 50%', // 終了位置 (例: 要素がビューポートの50%に来たとき)
        scrub: true, // スクロールに合わせてアニメーション
      },
    }
  );
}

function setGsap() {
  // gsap.to('#wave_01', { scale: 2, duration: 0 });
  gsap.registerPlugin(ScrollTrigger);
  document.querySelectorAll('.history-way').forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: 'top 80%',
      toggleClass: { targets: el, className: 'is-active' },
      once: true,
      onEnter: () => addAfter(el),
      // markers: true,
    });
  });
}
//gsapSphere
function setSphere() {
  gsap.registerPlugin(ScrollTrigger);
  gsap.to('#sphere_01', {
    // //アニメーションしたい要素を指定
    // x: 500,
    // y: 2000,
    // duration: 1,
    // ease: Power1.easeOut,
    scrollTrigger: {
      trigger: '.sphereCont_01', //アニメーションが始まるトリガーとなる要素
      start: 'top center', //アニメーションが始まる位置
      // markers: true,
      toggleClass: { targets: '#sphere_01', className: 'is-active' },
      once: true,
      onEnter: () => addAfter('#sphere_01'),
    },
  });
}

function addAfter(el) {
  var el = $(el);
  timer = setTimeout(function () {
    el.addClass('is-active-after');
  }, 1500);
}

// テキストアニメーション用span生成
function setSpan() {
  $('.txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

var countFlag = true;
// ///////waypoint
function setInview() {
  $('.way,.way-slow,.alphaWay,.js-way').on('inview', function () {
    var activePoint = $(this);
    activePoint.addClass('is-active');
    timer = setTimeout(function () {
      activePoint.addClass('is-active-after');
    }, 500);
  });
}

function setWay() {
  $('.way,.way-slow,.alphaWay,.js-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );

  $('.countStart').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        if (countFlag == true) {
          setCountAnime();
          countFlag = false;
        }
      }
    },
    {
      offset: '70%',
    }
  );
}

// ////////////////////////////アコーディオン
function setAcc() {
  $('.footerNav .icon,#menuPanel .icon').on('click', function () {
    $(this).parents('.hasChild').toggleClass('active');
    $(this).parents('.hasChild').find('.col-nav').stop().slideToggle('fast');
  });

  $('.tagCloud .head').on('click', function () {
    $(this).toggleClass('active');
    $(this).parent().find('.tags').stop().slideToggle('fast');
  });

  $('.accStyle .head').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).parent().find('.content').stop().slideToggle('fast');
  });
  // $('.accSec .ttl').on('click', function () {
  //   $(this).toggleClass('active');
  //   $(this).next().stop().slideToggle('fast');
  // });

  $('.ir-nav .hasChild .parent').on('click', function () {
    if ($('#wrapper').hasClass('setSp')) {
      $(this).parents('.hasChild').toggleClass('active');
      $(this).parents('.hasChild').find('.child').stop().slideToggle('fast');
    }
  });

  $('.faqSec .head').on('click', function () {
    $(this).next().stop().slideToggle('fast');
    $(this).parent().toggleClass('active');
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $('#wrapper,#loading').addClass('loaded');
  loadStart();
  // if ($('#wrapper').hasClass('home')) {
  //   loadStart()
  // }else {
  //   $('#wrapper').addClass('loadedDone')
  //   $('#wrapper').addClass('loadEnd')
  // }
}

function loadStart() {
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedDone');
  }, 200);
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedStart');
  }, 600);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
  }, 1500);
  if ($('#wrapper').hasClass('home')) {
    timer = setTimeout(function () {
      $('#wrapper').addClass('homeStart');
    }, 1200);
  } else {
    timer = setTimeout(function () {
      $('#wrapper').addClass('homeStart');
    }, 100);
  }
  if ($('#wrapper').hasClass('home')) {
    timer = setTimeout(function () {
      $('#wrapper').addClass('homeDelay');
    }, 2200);
  } else {
    timer = setTimeout(function () {
      $('#wrapper').addClass('pagesDelay');
    }, 500);
  }
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// function setGnav () {
//   var i = 0
//   setInterval(function () {
//     $('#headNav li').eq(i).addClass('start')
//     i++
//     if (i >= $('#headNav li').length) i = 0
//   }, 100)
// }

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// /////////////////////////////スムーススクロール
function setScroll() {
  var headerHeight = $('.headerMain .col-logo').height();

  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    // var position = target.offset().top;

    if ($(this).hasClass('unqNav')) {
      closeFnc();
    }

    setTimeout(function () {
      var position = null;

      if (window.getAnchorYPosition === undefined) {
        position =
          href == '#' || href == ''
            ? $('html').offset().top - headerHeight
            : target.offset().top - headerHeight;
      } else {
        position =
          href == '#' || href == ''
            ? $('html').offset().top - headerHeight
            : window.getAnchorYPosition(href, -headerHeight);
      }

      $('html, body').animate(
        {
          scrollTop: position,
        },
        400,
        'swing'
      );
    }, 100);

    e.preventDefault();
  });

  window.addEventListener('hashchange', function (e) {
    startScroll();
    e.preventDefault();
  });
}
function startScroll() {
  const url = $(location).attr('href');
  const headerHeight = $('header').outerHeight() + 30;

  if (url.indexOf('#') != -1) {
    const anchor = url.split('#');
    const target = $('#' + anchor[anchor.length - 1]);
    var position;

    // #wrapperに.philosophyクラスがついているかを確認
    if ($('#wrapper').hasClass('philosophy')) {
      // philosophyページではgetAnchorYPositionを使用
      position =
        window.getAnchorYPosition === undefined
          ? Math.floor(target.offset().top) - headerHeight
          : window.getAnchorYPosition(anchor[anchor.length - 1], -headerHeight);
    } else {
      // それ以外のページでは標準的なoffsetを使用
      position = Math.floor(target.offset().top) - headerHeight;
    }

    $('html, body').animate({ scrollTop: position }, 500);
  }

  setScroll();
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup() {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  setAutoHeight('.vinSec ul');
  setAutoHeight('.carouselStyle_04 .summary');
  setAutoHeight('.setH_09 .articleStyle_03 .content');
  var winW = $(window).width();
  if (winW > breakNum) {
    setAutoHeight('.setH_01', 3);
    setAutoHeight('.setH_02', 2);
    setAutoHeight('footer .setH_03');
    setAutoHeight('footer .setH_03');
    setAutoHeight('.setH_03', 4);
    setAutoHeight('.setH_05', 3);
    setAutoHeight('.setH_06', 2);
    setAutoHeight('.setH_07', 3);
    setAutoHeight('.setH_08', 4);
    // setAutoHeight('.setH_01 h2', 4)
    // setAutoHeight('.setH_01 h2')
    // setAutoHeight('#photoDiary .articleStyle_02 .inner')
    // setAutoHeight(".setH_01 .summary",3)
  } else {
    setAutoHeight('.setH_03', 2);
    setAutoHeight('.setH_03_sp', 2);
    setAutoHeight('.setH_04_sp');
    setAutoHeight('.setH_05_sp');
    setAutoHeight('.setH_06_sp');
    // setAutoHeight('.setH_01', 2);
    // setAutoHeight('.setH_02', 2);
    // setAutoHeight('.setH_03', 2);
    // setAutoHeight("#setH_08 h2",2)
  }
  setAutoHeight('.setH_04', 2);

  startResize();
}

function setAutoHeight(target, count) {
  $(target).tile(count);
}

function startResize() {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
